module.exports = __webpack_public_path__ + "img/4.b2b7ed41.webp";